<template>
    <div>
      <div style="position: relative;height: 35.47vw;width: 100%">
        <img src="../assets/img/login/loginBg.png" class="loginImg" />
        <div style="padding-top: 18.8vw;width: 100vw" class="centerBox">
          <div class="centerBox" style="font-size: 4.13vw;color: #232324;width: 50%;">登录</div>
          <div class="centerBox" @click="$router.push('/register')"  style="font-size: 4.13vw;color: white;width: 50%">注册</div>
        </div>
      </div>
<!--      <van-radio-group v-model="radio" direction="horizontal" style="width: 100vw;display: flex;margin-top: 7vw">-->
<!--        <van-radio :name="1" style="width: 50%;margin: 0" class="centerBox">-->
<!--          <template slot-scope="scope" slot="icon">-->
<!--            <img :src="scope.checked ? icon.activeIcon : icon.inactiveIcon" style="width: 3.33vw;" />-->
<!--          </template>-->
<!--          店主-->
<!--        </van-radio>-->
<!--        <van-radio :name="2" style="width: 50%;margin: 0" class="centerBox">-->
<!--          <template slot-scope="scope" slot="icon">-->
<!--            <img :src="scope.checked ? icon.activeIcon : icon.inactiveIcon" style="width: 3.33vw" />-->
<!--          </template>-->
<!--          运营商-->
<!--        </van-radio>-->
<!--      </van-radio-group>-->
      <van-form ref="MyForm" class="loginForm" style="margin-top: 16.4vw" :border="false" :show-error="false">
        <div style="" :class="`centerBox loginFormItem ${userFocus ? 'active' : ''}`">
          <img style="width: 4.53vw;height: 4.4vw" src="../assets/img/login/loginUser.png">
          <van-field
                  v-model="form.userName"
                  @input="formatSpace('userName')"
                  @focus="userFocus = true"
                  @blur="userFocus = false"
                  placeholder="用户名"
                  :rules="[{ required: true, message: '请填写用户名' }]"
          ></van-field>
        </div>
        <div style=""  :class="`centerBox loginFormItem ${passFocus ? 'active' : ''}`">
          <img style="width: 4.53vw;height: 4.4vw" src="../assets/img/login/loginPass.png">
        <van-field
          v-model="form.passwd"
          type="password"
          placeholder="密码"
          @focus="passFocus = true"
          @blur="passFocus = false"
          :rules="[{ required: true, message: '请填写密码' }, { pattern: /^[0-9A-Za-z]{6,}$/, message: '密码长度需在6到16位之间，且不允许有特殊字符'}]"
        ></van-field>
        </div>
        <div style="margin: 29vw 14vw 0;">
          <van-button round block color="#F45D59"
                      @keyup.enter.native="onSubmit" @keydown.enter.native.prevent @click="onSubmit"
                      type="info" native-type="submit">
            登录
          </van-button>
        </div>
      </van-form>
    </div>
</template>

<script>
import md5 from 'js-md5'
import activeIcon from '../assets/img/login/check.png'
import inactiveIcon from '../assets/img/login/chenkNo.png'
export default {
  name: 'login',
  data () {
    return {
      icon: {
        activeIcon,
        inactiveIcon
      },
      passFocus: false,
      userFocus: false,
      form: {
        recommendCode: '',
        userName: '',
        passwd: '',
        userTel: '',
        address: '',
        orgNo: '',
        contactUser: '',
        isAgreed: '',
        code: ''
      },
      radio: 1
    }
  },
  created () {
    this.$toast.clear()
    // this.$router.replace({path: '/login', query: {type: Math.random().toString()}})
    this.getCode('123')
    // if (window.history && window.history.pushState) {
    //   history.pushState(null, null, document.URL)
    //   window.addEventListener('popstate', this.goBack, false)
    // }
  },
  destroyed () {
    // window.removeEventListener('popstate', this.goBack, false)
  },
  methods: {
    getCode (state) {
      if (this.isWeChat()) {
        let urlNow = encodeURIComponent(window.location.href)
        // console.log(urlNow, 'urlNow')
        let scope = 'snsapi_base'
        let appid = 'wx5a69be1899d3fa56'
        let url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appid + '&redirect_uri=' + urlNow + '&response_' +
        'type=code&scope=' + scope + '&state=' + state + '&connect_redirect=1' + '#wechat_redirect'
        let code = this.getUrlParam('code')
        console.log(this.form.code, 'zheli')
        if (code == null || code === '') {
          this.form.code = ''
          console.log('没有code')
          window.location.replace(url)
        } else {
          this.form.code = this.getUrlParam('code')
        }
      }
    },
    getUrlParam (name) {
      let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
      let r = window.location.search.substr(1).match(reg)
      if (r != null) {
        return unescape(r[2])
      }
      return null
    },
    goBack () {
      this.$router.replace({ path: '/' })
    },
    formatSpace (val) {
      this.form[val] = this.form[val].replace(/ /g, '')
    },
    loginHsbcUser () {
      this.$toast.loading({
        duration: 0
      })
      const self = this
      self.$request.login.loginHsbcUser({
        ...self.form,
        passwd: md5(self.form.passwd)
      })
        .then((response) => {
          this.$toast.clear()
          self.$toast(response.msg)
          if (response.code === '200') {
            window.localStorage.setItem('token', response.data.token)
            window.localStorage.setItem('avatar', response.data.avatar || '')
            window.localStorage.setItem('orderStartTime', response.data.orderStartTime || '')
            window.localStorage.setItem('orderEndTime', response.data.orderEndTime || '')
            setTimeout(function () {
              self.$router.push('/myMenu/shop')
              // window.location.href = process.env.VUE_APP_API_URL + '/#/myMenu/shop'
            }, 300)
          } else {
          }
        })
    },
    loginOperatorUser () {
      this.$toast.loading({
        duration: 0
      })
      const self = this
      self.$request.login.loginOperatorUser({
        ...self.form,
        passwd: md5(self.form.passwd)
      })
        .then((response) => {
          this.$toast.clear()
          self.$toast(response.msg)
          if (response.code === '200') {
            window.localStorage.setItem('token', response.data.token)
            window.localStorage.setItem('avatar', response.data.avatar || '')
            setTimeout(function () {
              self.$router.push('/doorList')
              // window.location.href = process.env.VUE_APP_API_URL + '/#/doorList'
            }, 300)
          } else {
          }
        })
    },
    onSubmit () {
      const self = this
      // if (self.form.userName === '测试code用户名') {
      //   self.$toast({
      //     duration: 0,
      //     message: self.form.code
      //   })
      //   return
      // }
      self.$refs.MyForm.validate()
        .then(() => {
          if (this.radio === 1) {
            this.loginHsbcUser()
          } else {
            this.loginOperatorUser()
          }
        }).catch((error) => {
        })
    },
    getUrlParam (name) {
      const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
      const r = window.location.search.substr(1).match(reg)
      if (r != null) {
        return unescape(r[2])
      }
      return null
    },
    isWeChat () {
      return String(navigator.userAgent.toLowerCase().match(/MicroMessenger/i)) === 'micromessenger'
    },
    goRegister () {
      this.$router.push({ name: 'Register' })
    },
    goForget () {
      this.$router.push({ name: 'Forget' })
    },
    onClickLeft () {
      this.$router.replace({ path: '/' })
    }
  }
}
</script>

<style>
.loginForm .van-cell::after{
  border: none;
}
  .loginFormItem {
    display: flex;width: calc(72vw - 5.8vw);margin: 31px auto;
    border-radius: 51px;overflow: hidden;
    padding-left: 5.8vw;
  }
  .loginFormItem.active {
    box-shadow: 0px 4px 45px 0px rgba(244,93,89,0.14);
  }
</style>
